import {Tooltip} from 'platform/components';

import {ColorBorder, StyledColorCircle} from './styles';

type ColorCircleProps = {
  className?: string;
  colorLabel?: string;
  colorCode?: string;
  size?: 'default' | 'large';
  needBorder?: boolean;
  isSelected?: boolean;
  isDisabled?: boolean;
  onClick?: () => void;
};

export function ColorCircle({
  colorLabel,
  colorCode,
  size,
  onClick,
  isSelected,
  needBorder,
  isDisabled,
  ...rest
}: ColorCircleProps) {
  return (
    <Tooltip label={colorLabel} placement="top">
      <ColorBorder {...rest} $isSelected={isSelected} $isDisabled={isDisabled}>
        <StyledColorCircle
          $color={colorCode ?? 'transparent'}
          $size={size === 'large' ? 6 : undefined}
          onClick={onClick}
          $needBorder={needBorder}
          $isDisabled={isDisabled}
        />
      </ColorBorder>
    </Tooltip>
  );
}
